import { useState } from 'react';

export default function CuevaParaDos() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const images = [
    {
      url: "https://i.imgur.com/6FkqQVi.jpg",
      alt: "Cueva para Dos - Romantyczne doświadczenie"
    },
    {
      url: "https://i.imgur.com/RzLMVpm.jpg",
      alt: "Cueva para Dos - Kolacja w jaskini"
    }
  ];

  return (
    <>
      <section id="cueva-para-dos" className="py-32 px-6 bg-gradient-to-br from-rose-50 via-white to-amber-50 relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-rose-200/20 rounded-full blur-3xl -z-10"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-amber-200/20 rounded-full blur-3xl -z-10"></div>
        
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-block mb-6">
              <div className="flex items-center gap-3 bg-gradient-to-r from-rose-600 to-amber-600 text-white px-6 py-2 rounded-full shadow-lg">
                <i className="ri-heart-3-fill text-2xl"></i>
                <span className="text-sm font-medium uppercase tracking-wider">Ekskluzywne Doświadczenie</span>
              </div>
            </div>
            <h2 className="text-5xl md:text-6xl font-light text-stone-800 mb-6">
              Cueva para Dos
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-rose-400 via-amber-400 to-rose-400 mx-auto mb-8"></div>
            <p className="text-2xl md:text-3xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-rose-600 to-amber-600 mb-6">
              Jedna z najbardziej ekskluzywnych usług na Wyspach Kanaryjskich
            </p>
            <p className="text-xl text-stone-600 max-w-3xl mx-auto leading-relaxed">
              Niezapomniane wspomnienie dla par. Romantyczna kolacja w naturalnej jaskini 
              z widokiem na Atlantyk — wyjątkowe doświadczenie, które pozostanie w sercu na zawsze.
            </p>
          </div>

          {/* Photo Gallery */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            {images.map((image, index) => (
              <div 
                key={index}
                className="relative group overflow-hidden rounded-2xl shadow-2xl cursor-pointer h-[500px]"
                onClick={() => setSelectedImage(index)}
              >
                <div className="w-full h-full">
                  <img 
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-6 left-6 text-white">
                    <i className="ri-zoom-in-line text-3xl"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-rose-100">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-rose-100 to-amber-100 rounded-full mb-5">
                <i className="ri-map-pin-line text-rose-600 text-3xl"></i>
              </div>
              <h4 className="text-xl font-semibold text-stone-800 mb-3">Wyjątkowa Lokalizacja</h4>
              <p className="text-stone-600 leading-relaxed">
                Naturalna jaskinia wykuta w klifie z zapierającymi dech widokami na ocean Atlantycki. 
                Unikalne miejsce dostępne tylko w Hotel Jardín Tecina.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-rose-100">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-rose-100 to-amber-100 rounded-full mb-5">
                <i className="ri-restaurant-line text-rose-600 text-3xl"></i>
              </div>
              <h4 className="text-xl font-semibold text-stone-800 mb-3">Menu Degustacyjne</h4>
              <p className="text-stone-600 leading-relaxed">
                Ekskluzywne menu przygotowane przez szefa kuchni specjalnie dla dwojga. 
                Wykwintne dania, wino premium i obsługa najwyższej klasy.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-rose-100">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-rose-100 to-amber-100 rounded-full mb-5">
                <i className="ri-group-line text-rose-600 text-3xl"></i>
              </div>
              <h4 className="text-xl font-semibold text-stone-800 mb-3">Dostępność</h4>
              <p className="text-stone-600 leading-relaxed">
                Doświadczenie dostępne zarówno dla gości hotelowych, jak i klientów zewnętrznych. 
                Idealne miejsce na wyjątkowe okazje dla wszystkich.
              </p>
            </div>
          </div>

          {/* Experience Details */}
          <div className="bg-gradient-to-r from-stone-800 to-stone-700 rounded-2xl p-12 text-white shadow-2xl mb-16">
            <h3 className="text-3xl font-light mb-8 text-center">
              Co obejmuje doświadczenie?
            </h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Rezerwacja prywatna</h5>
                  <p className="text-stone-200 leading-relaxed">
                    Jaskinia zarezerwowana wyłącznie dla pary. Całkowita prywatność i intymność.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Menu 5-daniowe</h5>
                  <p className="text-stone-200 leading-relaxed">
                    Wykwintne dania przygotowane przez szefa kuchni z lokalnych produktów premium.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Sommelier i wina premium</h5>
                  <p className="text-stone-200 leading-relaxed">
                    Dobór win przez sommeliera idealnie pasujących do każdego dania.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Obsługa dyskretna</h5>
                  <p className="text-stone-200 leading-relaxed">
                    Profesjonalny personel zapewniający najwyższą jakość obsługi z poszanowaniem prywatności.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Widoki na ocean</h5>
                  <p className="text-stone-200 leading-relaxed">
                    Niezapomniane widoki na zachód słońca nad Atlantykiem z unikalnej perspektywy jaskini.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-500/30 rounded-lg flex-shrink-0">
                  <i className="ri-add-line text-2xl text-amber-300"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Dekoracje specjalne <span className="text-amber-300 text-sm font-normal">(opcja dodatkowa)</span></h5>
                  <p className="text-stone-200 leading-relaxed">
                    Dekoracje romantyczne, płatki róż, świece, balony — dostępne na zamówienie za dodatkową opłatą.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* B2B Highlight */}
          <div className="bg-gradient-to-r from-rose-50 to-amber-50 rounded-2xl p-10 border-2 border-rose-200 shadow-xl">
            <div className="flex items-start gap-6">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-rose-500 to-amber-500 rounded-full flex-shrink-0">
                <i className="ri-vip-crown-line text-white text-3xl flex-shrink-0 mt-0.5"></i>
              </div>
              <div>
                <h3 className="text-3xl font-semibold text-stone-800 mb-4">
                  Argument B2B Premium dla Twoich Klientów VIP
                </h3>
                <p className="text-lg text-stone-700 mb-4 leading-relaxed">
                  <strong>Cueva para Dos to USP (Unique Selling Point) najwyższej klasy.</strong> 
                  To doświadczenie jest dostępne TYLKO w Hotel Jardín Tecina i jest jedną z najbardziej ekskluzywnych 
                  usług romantycznych na całych Wyspach Kanaryjskich.
                </p>
                
                {/* Información importante */}
                <div className="bg-teal-50 border border-teal-200 rounded-lg p-4 mb-6">
                  <div className="flex items-start gap-3">
                    <i className="ri-information-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                    <p className="text-teal-800">
                      <strong>Ważne:</strong> Doświadczenie dostępne zarówno dla gości hotelowych, jak i klientów zewnętrznych. 
                      Możesz oferować to doświadczenie wszystkim swoim klientom, niezależnie od tego, czy nocują w hotelu.
                    </p>
                  </div>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-md">
                  <h4 className="font-semibold text-stone-800 mb-3 text-xl">Jak sprzedawać to doświadczenie?</h4>
                  <ul className="space-y-3 text-stone-700">
                    <li className="flex items-start gap-3">
                      <i className="ri-star-fill text-amber-500 text-xl flex-shrink-0 mt-1"></i>
                      <span><strong>Podróże poślubne:</strong> Idealne dla nowożeńców szukających wyjątkowych wspomnień</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-star-fill text-amber-500 text-xl flex-shrink-0 mt-1"></i>
                      <span><strong>Rocznice:</strong> Świętuj jubileusze małżeńskie z klasą i stylem</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-star-fill text-amber-500 text-xl flex-shrink-0 mt-1"></i>
                      <span><strong>Oświadczyny:</strong> Niezapomniane miejsce na pytanie o rękę</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-star-fill text-amber-500 text-xl flex-shrink-0 mt-1"></i>
                      <span><strong>Klienci VIP:</strong> Doświadczenie premium dla najbardziej wymagających gości</span>
                    </li>
                  </ul>
                </div>
                
                {/* Nota sobre extras */}
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mt-6">
                  <div className="flex items-start gap-3">
                    <i className="ri-gift-line text-amber-600 text-xl flex-shrink-0 mt-0.5"></i>
                    <p className="text-amber-800">
                      <strong>Opcje dodatkowe:</strong> Dekoracje romantyczne lub specjalne (płatki róż, świece, balony, kwiaty) 
                      dostępne na zamówienie za dodatkową opłatą. Idealne do personalizacji doświadczenia dla klientów VIP.
                    </p>
                  </div>
                </div>
                
                <p className="text-stone-700 mt-6 leading-relaxed">
                  💡 <strong>Tip sprzedażowy:</strong> Użyj określenia "jedna z najbardziej ekskluzywnych usług na Wyspach Kanaryjskich" 
                  w materiałach marketingowych. To nie przesada — to faktycznie unikalne doświadczenie niedostępne nigdzie indziej.
                </p>
              </div>
            </div>
          </div>

          {/* Booking Info */}
          <div className="mt-16 text-center">
            <div className="bg-stone-800 text-white rounded-xl p-8 inline-block">
              <i className="ri-calendar-check-line text-4xl mb-4"></i>
              <h4 className="text-2xl font-semibold mb-3">
                Rezerwacja z wyprzedzeniem obowiązkowa
              </h4>
              <p className="text-lg text-stone-200 leading-relaxed max-w-2xl">
                Ze względu na ekskluzywność tego doświadczenia, rezerwacja musi być dokonana 
                z odpowiednim wyprzedzeniem. Skontaktuj się z naszym zespołem B2B, aby sprawdzić dostępność 
                i zarezerwować ten wyjątkowy wieczór dla swoich klientów.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage !== null && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-6"
          onClick={() => setSelectedImage(null)}
        >
          <button 
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line text-3xl"></i>
          </button>
          
          <div className="max-w-6xl w-full">
            <img 
              src={images[selectedImage].url}
              alt={images[selectedImage].alt}
              className="w-full h-auto rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>

          {/* Navigation arrows */}
          {selectedImage > 0 && (
            <button
              className="absolute left-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(selectedImage - 1);
              }}
            >
              <i className="ri-arrow-left-line text-2xl"></i>
            </button>
          )}
          
          {selectedImage < images.length - 1 && (
            <button
              className="absolute right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(selectedImage + 1);
              }}
            >
              <i className="ri-arrow-right-line text-2xl"></i>
            </button>
          )}
        </div>
      )}
    </>
  );
}
